import ToolCatalog from "../components/ToolCatalog";

export default function MultiToolsPage() {
  return (
    <ToolCatalog
      title="Multi Tools"
      subtitle="A comprehensive suite of web scraping, keyword research, and SEO analysis tools powered by DataForSEO and Firecrawl APIs."
    />
  );
}
